import * as Sentry from '@sentry/react';
import type { ErrorEvent, EventHint } from '@sentry/react';

import { env } from '@/lib/env';

const PHI_REDACTED_TAG = '[REDACTED]';

const PHI_LIKE_KEYS = new Set([
  'conditions',
  'medications',
  'allergies',
  'insurance_info',
  'primary_physician',
  'care_preferences',
  'messages',
  'content',
  'notes',
]);

export function initSentry(): void {
  if (!env.VITE_SENTRY_DSN) return;
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 0,
    sendDefaultPii: false,
    beforeSend(event: ErrorEvent, _hint: EventHint): ErrorEvent | null {
      if (event.request?.cookies) delete event.request.cookies;
      if (event.user?.email) event.user.email = PHI_REDACTED_TAG;
      if (event.extra) {
        event.extra = redactObject(event.extra);
      }
      return event;
    },
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.data) {
        breadcrumb.data = redactObject(breadcrumb.data);
      }
      return breadcrumb;
    },
  });
}

function redactObject(obj: Record<string, unknown>): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj)) {
    if (PHI_LIKE_KEYS.has(key)) {
      result[key] = PHI_REDACTED_TAG;
    } else if (value && typeof value === 'object' && !Array.isArray(value)) {
      result[key] = redactObject(value as Record<string, unknown>);
    } else {
      result[key] = value;
    }
  }
  return result;
}
